<ng-container [formGroup]="form">
  <div class="field-group field-group--labeled">
    <div class="tooltip-container">
      <b3-input-select
        [formControlName]="ufControl"
        [inputId]="ufControl"
        [label]="ufLabel"
        [placeholder]="ufPlaceholder"
        background="white"
        maxHeight="280px"
        [options]="selectUF">
        <b3-input-select-option
          *ngFor="let item of selectUF; let i = index"
          [attr.value]="item.inputId"
          [attr.index]="i"
          [id]="ufControl + '-option-' + item.inputId">
          {{ item.label }}
        </b3-input-select-option>
      </b3-input-select>
      <span class="tooltip-text">Selecione a UF onde o projeto foi desenvolvido</span>
    </div>
  </div>

  <div class="field-group field-group--labeled">
    <div class="tooltip-container">
      <b3-input-text
        *ngIf="hasCityLoadError; else citySelect"
        [formControlName]="cityControl"
        [inputId]="cityControl"
        [label]="cityLabel"
        background="white"
        mask="text"
        placeholder="Digite a cidade">
      </b3-input-text>

      <ng-template #citySelect>
        <b3-input-select
          [formControlName]="cityControl"
          [inputId]="cityControl"
          [label]="cityLabel"
          [placeholder]="cityPlaceholder"
          background="white"
          maxHeight="280px"
          [options]="selectCity">
          <b3-input-select-option
            *ngFor="let item of selectCity; let i = index"
            [attr.value]="item.inputId"
            [attr.index]="i"
            [id]="cityControl + '-option-' + item.inputId">
            {{ item.label }}
          </b3-input-select-option>
        </b3-input-select>
      </ng-template>

      <span *ngIf="!hasCityLoadError" class="tooltip-text">
        Selecione o município onde o projeto foi desenvolvido
      </span>
      <span *ngIf="hasCityLoadError" class="tooltip-text">
        Não foi possível carregar os municípios. Digite o município onde o projeto foi desenvolvido.
      </span>
    </div>
  </div>
</ng-container>
